<template>
    <div class="c-template-header">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "TemplateHeader",
};
</script>

<style scoped lang="less">
.c-template-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 72px;
}
@media only screen and (max-width: 1200px) {
    .c-template-header {
        padding-top: 64px;
    }
}
@media only screen and (max-width: 768px) {
    .c-template-header {
        padding-top: 56px;
    }
}
@media only screen and (max-width: 480px) {
    .c-template-header {
        padding-top: 48px;
    }
}
</style>
